import ProtectedContainer from "components/guards/ProtectedContainer";
import { IChildProp } from "lib/interfaces/IChildProp";
import React from "react";

interface IOnlyPromoterProps extends IChildProp {
  eventId?: string;
}

/**
 * Visible only to Admin, Host, Promoter
 *
 * @param props
 */
const OnlyPromoter = (props: IOnlyPromoterProps) => {
  return (
    <ProtectedContainer promoter={true} eventId={props.eventId}>
      {props.children}
    </ProtectedContainer>
  );
};

export default OnlyPromoter;



// WEBPACK FOOTER //
// ./src/components/guards/OnlyPromoter.tsx